export const removeAllAssign = (payload: any) => ({
    type: "@saga/DELETE_ALL_ASSIGN",
    payload
});